// react core
import { lazy } from "react";

// entzy event models
import { createEventModuleList } from "models/event";

// entzy lazy single level components
// const EventMenu = lazy(() => import("components/event/EventMenu"));

// entzy lazy widget components
// const EventWidgetHeader = lazy(
//   () => import("components/event/widgets/WidgetHeader"),
// );
// const EventWidgetDates = lazy(
//   () => import("components/event/widgets/WidgetDates"),
// );
// const EventWidgetMessaging = lazy(
//   () => import("components/event/widgets/WidgetMessaging"),
// );
// const EventWidgetLocations = lazy(
//   () => import("components/event/widgets/WidgetLocations"),
// );

// entzy lazy room components
const EventRoomLaunchpad = lazy(
  () => import("components/event/rooms/RoomLaunchpad"),
);
const EventRoomLaunchpadTickets = lazy(
  () => import("components/event/rooms/RoomLaunchpadTickets"),
);
const EventRoomLaunchpadGallery = lazy(
  () => import("components/event/rooms/RoomLaunchpadFrames"),
);
const EventRoomSharing = lazy(
  () => import("components/event/rooms/RoomSharing"),
);
const EventRoomDates = lazy(() => import("components/event/rooms/RoomDates"));
const EventRoomMessaging = lazy(
  () => import("components/event/rooms/RoomMessaging"),
);
const EventRoomLocations = lazy(
  () => import("components/event/rooms/RoomLocations"),
);
const EventRoomStore = lazy(() => import("components/event/rooms/RoomStore"));
const EventRoomInfo = lazy(
  () => import("components/event/rooms/RoomLaunchpadCriteria"),
);
const EventRoomEntry = lazy(() => import("components/event/rooms/RoomEntry"));
const EventRoomMembers = lazy(
  () => import("components/event/rooms/RoomMembers"),
);

// entzy dynamic widgets
// export const renderEventWidget = function (props) {
//   const module = createEventModuleList().filter(
//     (obj) => obj.id === props.id,
//   )[0];
//   switch (props.id) {
//     case "menu":
//       return <EventMenu {...props} module={module} />;
//     case "header":
//       return <EventWidgetHeader {...props} module={module} />;
//     case "dates":
//       return <EventWidgetDates {...props} module={module} />;
//     case "messaging":
//       return <EventWidgetMessaging {...props} module={module} />;
//     case "locations":
//       return <EventWidgetLocations {...props} module={module} />;
//     default:
//       return <></>;
//   }
// };

// entzy dynamic rooms
export const renderEventRoom = function (props) {
  const module = createEventModuleList().filter(
    (obj) => obj.id === props.id,
  )[0];
  switch (props.id) {
    case "menu":
      // return <EventMenu {...props} module={module} />;
      return <></>;

    case "launchpad":
      return <EventRoomLaunchpad {...props} module={module} />;
    case "sharing":
      return <EventRoomSharing {...props} module={module} />;
    case "dates":
      return <EventRoomDates {...props} module={module} />;
    case "messaging":
      return <EventRoomMessaging {...props} module={module} />;
    case "locations":
      return <EventRoomLocations {...props} module={module} />;
    case "entry":
      return <EventRoomEntry {...props} module={module} />;

    case "tickets":
      return <EventRoomLaunchpadTickets {...props} module={module} />;
    case "gallery":
      return <EventRoomLaunchpadGallery {...props} module={module} />;
    case "members":
      return <EventRoomMembers {...props} module={module} />;
    case "store":
      return <EventRoomStore {...props} module={module} />;
    case "info":
      return <EventRoomInfo {...props} module={module} />;

    default:
      return <></>;
  }
};
